import React, {useEffect, useState} from "react";
import {Typography, Modal, FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { useForm, Controller  } from "react-hook-form";

import SimpleBar from 'simplebar-react';

import ButtonMain from "../button/Button_main";
import ButtonImgMain from "../button/Button_img_main";
import './Modal_style.scss'

import AiIcon from '../../assets/ai-generate.svg'
import LoadingIcon from '../../assets/tube-spinner.svg'

const ModalAiJobCreate = (props) => {

    const {register, handleSubmit, control, formState: { errors }, reset} = useForm();
    const [jobReq, setJobReq] = useState({})

    //form submit

    const submit  = (data) => {
        console.log('data ai > ', data)
        const transformedData = {...data, skills:[data.skills], responsibilities:[data.responsibilities]}
        console.log('transformedData > ', transformedData)
        props.generateJobApi(transformedData)

    }

    //clear the data after submit

    useEffect(()=>{
        if(!props.openAiJobCreate){
            reset({})
        }
    },[props.openAiJobCreate])

    // cancel
   
    const cancel = () => {
        props.setOpenAiJobCreate(false)
        reset({})
    }

    return(
            <Modal
                open={props.openAiJobCreate}
               // onClose={()=>props.setOpenJobView(false)}
                aria-labelledby="modal-modal-title"
            >   
                <div className="modal-container modal-view">
         
                        <Typography id="modal-modal-title" variant="text20" className="mb-5-modal border-bottom-modal" component="div">
                            AI Job Creator
                        </Typography>
                        <form onSubmit={handleSubmit(data => submit(data))}>
                            <SimpleBar className="modal-max-h-60vh-auto modal-p-0 modal-m-0">
                                <div>
                                    <FormControl fullWidth variant="standard">
                                        <div className="flex justify-between">
                                            <InputLabel shrink htmlFor="jobTitle">Job Title</InputLabel>
                                            {errors.title && <span className="text-red font-medium text-sm">Job title is required</span>}
                                        </div>
                                        <OutlinedInput
                                            id="jobTitle"
                                            placeholder="Head of Sales"
                                            type='text'
                                            
                                            {...register("title", { required:true} )}
                                        />
                                    </FormControl>
                                    <FormControl fullWidth variant="standard">
                                        <div className="flex justify-between">
                                            <InputLabel shrink htmlFor="skill">Key Skills</InputLabel>
                                            {errors.skills && <span className="text-red font-medium text-sm">Key skills are required</span>}
                                        </div>
                                        <OutlinedInput
                                            id="skill"
                                            placeholder="Strategic planning, team management, B2B sales, CRM expertise"
                                            type='text'
                                            multiline={true}
                                            maxRows={2}
                                            className="p-0"
                                            {...register("skills", { required:true} )}
                                        />
                                    </FormControl>
                                    <FormControl fullWidth variant="standard">
                                        <div className="flex justify-between">
                                            <InputLabel shrink htmlFor="ref">Required Experience</InputLabel>
                                            {errors.experienceLevel && <span className="text-red font-medium text-sm">Experience is required</span>}
                                        </div>
                                        <OutlinedInput
                                            id="ref"
                                            placeholder="7+ years in sales leadership roles"
                                            type='text'
                                            multiline={true}
                                            maxRows={5}
                                            className="p-0"
                                            {...register("experienceLevel", { required:true} )}
                                        />
                                    </FormControl>
                                    <FormControl fullWidth variant="standard">
                                        <div className="flex justify-between">
                                            <InputLabel shrink htmlFor="ref">Job Responsibilities <span className="text-grayLight font-medium text-sm">(Optional)</span></InputLabel>
                                        </div>
                                        <OutlinedInput
                                            id="ref"
                                            placeholder="Develop and execute sales strategies to meet revenue targets"
                                            type='text'
                                            multiline={true}
                                            maxRows={2}
                                            className="p-0"
                                            {...register("responsibilities" )}
                                        />
                                    </FormControl>
                                    <FormControl fullWidth variant="standard">
                                        <div className="flex justify-between">
                                            <InputLabel shrink htmlFor="ref">Educational Qualifications <span className="text-grayLight font-medium text-sm">(Optional)</span></InputLabel>
                                        </div>
                                        <OutlinedInput
                                            id="ref"
                                            placeholder="Bachelor's degree in Business Administration or related field"
                                            type='text'
                                            multiline={true}
                                            maxRows={2}
                                            className="p-0"
                                            {...register("educationLevel" )}
                                        />
                                    </FormControl>
                                </div>
                            </SimpleBar>
                            <div className="modal-footer-right mt-5-modal pt-5-modal border-top-modal">
                                <ButtonMain 
                                    variant='primaryOutline' 
                                    type='button' 
                                    disabled={false} 
                                    name='Cancel'
                                    class='modal-capitalize'
                                    onClick={cancel}
                                />
                                <ButtonImgMain 
                                    variant='purple' 
                                    type='submit' 
                                    disabled={false} 
                                    name={'Create'}
                                    class='capitalize ai-btn ml-4'
                                    img={props.aiGenerating ? LoadingIcon: AiIcon}
                                    posision={''}
                                    onClick={props.aiJobCreate}
                                />
                            </div>
                        </form>
                </div>
                
            </Modal>
    )
}

export default ModalAiJobCreate;